import { render, staticRenderFns } from "./ThkMaterialBoxEdit.vue?vue&type=template&id=5a4849aa&scoped=true"
import script from "./ThkMaterialBoxEdit.vue?vue&type=script&lang=js"
export * from "./ThkMaterialBoxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4849aa",
  null
  
)

export default component.exports